// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Link: 'link',
	Link1: 'link-1',
	Button: 'button',
	StartOrderButton: 'start-order-button',
	ResubmitOrderButton: 'resubmit-order-button',
	MessageBar: 'message-bar',
	StewartMessageContainer: 'stewart-message-container',
	StewartMessageContainer1: 'stewart-message-container-1',
	SmartOrderFormLink: 'smart-order-form-link',
	SmartOrderFormLink1: 'smart-order-form-link-1',
	EditPrioritySpan: 'edit-priority-span',
	EditPrioritySpan1: 'edit-priority-span-1',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
